import { Modal } from 'antd';
import styles from './index.less';
import { closeOnImg } from '@/asserts/imgs/common/index'
import common from '@/asserts/js/common';
const MobilePopup = ({ visible, onClose, imageUrl, linkUrl, isPC, isTablet, isMobile }) => {
  const handleClick = () => {
    onClose();
    setTimeout(()=>{
      //ios端
      if(common.isiOS){
        window.location.href = linkUrl;
        return
      }
       //android终端、PC端
        window.open(linkUrl, '_blank');
    },100)
  };
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      wrapClassName={styles.mobilePopupWrap}
      closable={true}
      closeIcon={
        <img
          src={closeOnImg}
          alt='close'
          className={[styles.closeButton, isMobile && styles.mobile, isTablet && styles.tablet, isPC && styles.pc].filter(Boolean).join(' ')} />
      }
    >
        <div
          className={styles.imageContainer}
          style={{
            backgroundImage: `url(${imageUrl})`
          }}
          onClick={handleClick}
        >
        </div>
    </Modal>
  );
};

export default MobilePopup;
